import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterLoanAgrGeneralPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='loan_agreement_general'
        title='General terms'
        activeTab='loanAgreement'
        navConfig={{ loanAgrPage: 'general' }}
      />
    )
  }
}

export default MasterLoanAgrGeneralPageSF
